/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LicenseNumber
 */
export interface LicenseNumber {
}

/**
 * Check if a given object implements the LicenseNumber interface.
 */
export function instanceOfLicenseNumber(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LicenseNumberFromJSON(json: any): LicenseNumber {
    return LicenseNumberFromJSONTyped(json, false);
}

export function LicenseNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicenseNumber {
    return json;
}

export function LicenseNumberToJSON(value?: LicenseNumber | null): any {
    return value;
}

